import type { FC, ReactNode } from 'react'
import type { Invoice } from '@/types'

import { CircleCheck, Copy, Ellipsis, FileText, RotateCcw } from 'lucide-react'
import { Button } from '@/components/ui/button'

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'

interface InvoiceActionsMenuProps {
    invoice: Invoice
    onView: (invoice: Invoice) => void
    onCopyNumber: (invoice: Invoice) => void
    onMarkPaid: (invoice: Invoice) => void
    onRefund: (invoice: Invoice) => void
}

export const InvoiceActionsMenu: FC<InvoiceActionsMenuProps> = ({ invoice, onView, onCopyNumber, onMarkPaid, onRefund }): ReactNode => {
    const canMarkPaid = invoice.status === 'pending' || invoice.status === 'failed'

    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                render={<Button variant='ghost' size='icon-sm' aria-label={`Aksi untuk faktur ${invoice.number}`} />}
                onClick={(event) => event.stopPropagation()}
            >
                <Ellipsis />
            </DropdownMenuTrigger>

            <DropdownMenuContent align='end' className='w-52'>
                <DropdownMenuGroup>
                    <DropdownMenuItem onClick={() => onView(invoice)}>
                        <FileText />
                        Lihat faktur
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => onCopyNumber(invoice)}>
                        <Copy />
                        Salin nomor faktur
                    </DropdownMenuItem>
                </DropdownMenuGroup>

                {(canMarkPaid || invoice.status === 'paid') && (
                    <>
                        <DropdownMenuSeparator />
                        <DropdownMenuGroup>
                            {canMarkPaid && (
                                <DropdownMenuItem onClick={() => onMarkPaid(invoice)}>
                                    <CircleCheck />
                                    Tandai lunas
                                </DropdownMenuItem>
                            )}
                            {invoice.status === 'paid' && (
                                <DropdownMenuItem variant='destructive' onClick={() => onRefund(invoice)}>
                                    <RotateCcw />
                                    Kembalikan dana
                                </DropdownMenuItem>
                            )}
                        </DropdownMenuGroup>
                    </>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
